import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/8_neon-2/8_neon-2"
 * Contains 6 texture(s)
 */
export class CardsFront8Neon2Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/8_neon-2/8_neon-2';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'ace-spades.png',
        'ace-hearts.png',
        'ace-diamonds.png',
        'ace-clubs.png',
        '9-spades.png',
        '9-hearts.png'
    ] as const;
}
